import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const categoryApi = createApi({
    reducerPath: "categoryApi",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ["Category"],
    endpoints: (builder) => ({
        getAllCategory: builder.query({
            query: ({ pageno, search, limit }) => {
                let url = `/contractor/categories?pageno=${pageno}`;
                if (search) {
                    url += `&search=${search}`;
                }
                if (limit) {
                    url += `&limit=${limit}`;
                }
                return {
                    url,
                    method: "GET",
                }
            },
            providesTags: ["Category"],
        }),
        addCategory: builder.mutation({
            query: (data) => ({
                url: `/contractor/category`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Category"],
        }),
        updateCategory: builder.mutation({
            query: ({ id, data }) => ({
                url: `/contractor/category/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["Category"],
        }),
        deleteCategory: builder.mutation({
            query: (id) => ({
                url: `/contractor/category/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Category"],
        }),
    }),
});

export const {
    useGetAllCategoryQuery,
    useAddCategoryMutation,
    useUpdateCategoryMutation,
    useDeleteCategoryMutation,
} = categoryApi;